module.exports = __webpack_public_path__ + "static/img/loading.9b4a4e5.gif";